// Half-width Katakana (U+FF61 - U+FF9F) -> Shift-JIS (0xA1 - 0xDF) - single byte
export const HW_KATAKANA_START = 0xff61;
